export const fmtInt = (n) =>
  new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 }).format(n || 0);

export const fmtDec = (n, d = 2) =>
  new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  }).format(n || 0);

export const fmtMoney = (n, d = 2) => `$ ${fmtDec(n, d)}`;

export const fmtPct = (n, d = 2) => `${fmtDec(n, d)} %`;

// compact for axis ticks (e.g. 1.2M, 850K)
export const fmtCompact = (n) =>
  new Intl.NumberFormat("es-MX", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(n || 0);
